"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = CreditMenu;

var _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _index = require("../../../../../index");

require("../styles/_credit-menu.scss");

function CreditMenu(a) {
  var b = a.creditType,
      c = a.creditBalance,
      d = a.isUnlimited,
      e = a.teams,
      f = a.hasTeamsCredits;
  return "TEAM" !== b || e.length ? _react["default"].createElement("div", {
    className: "credit-menu"
  }, f ? _react["default"].createElement("div", {
    className: "credit-menu__teams"
  }, e.map(function (a) {
    var b = a.teamId,
        c = a.imageUrl,
        d = a.name,
        e = a.creditBalance,
        f = e.balance + e.rolloverBalance;
    return _react["default"].createElement("div", {
      key: b,
      className: "credit-menu__teams__team"
    }, _react["default"].createElement("div", {
      className: "credit-menu__teams__team__image"
    }, _react["default"].createElement(_uiKit.Image, {
      width: "50px",
      height: "50px",
      placeholderText: d,
      placeholderTextSize: 15,
      defaultIconColour: "regent",
      imageUrl: c,
      rounded: !0
    })), _react["default"].createElement("div", {
      className: "credit-menu__teams__team__info"
    }, _react["default"].createElement(_uiKit.Text, {
      heading5: !0,
      noMargin: !0
    }, d), _react["default"].createElement("div", {
      className: "credit-menu__teams__team__info__credits"
    }, _react["default"].createElement(_uiKit.Icon, {
      name: "credits",
      size: 15,
      color: "black"
    }), _react["default"].createElement(_uiKit.Text, {
      label: !0,
      noMargin: !0
    }, "".concat(f, " credits")))));
  })) : _react["default"].createElement("div", {
    className: "credit-menu__share"
  }, _react["default"].createElement(_index.CreditsOverview, {
    creditBalance: c,
    isUnlimited: d
  }))) : _react["default"].createElement(_uiKit.Text, {
    noMargin: !0
  }, "You aren't in any teams with credits.");
}